import PropTypes from "prop-types";
import React from "react";
import OkInput from "shared/components/oknf/OkInput";
import OkCheckbox from "shared/components/oknf/OkCheckbox";
import Str from "shared/components/Str";

class TwoFactor extends React.Component {
	static propTypes = {
		authcode: PropTypes.string.isRequired,
		saveAuth: PropTypes.bool.isRequired,
		onChangeAuthcode: PropTypes.func.isRequired,
		onChangeSaveAuth: PropTypes.func.isRequired,
	};

	_onChangeAuthcode = (ev) => {
		this.props.onChangeAuthcode(ev.target.value);
	};

	_onChangeSaveAuth = (ev) => {
		this.props.onChangeSaveAuth(ev.target.checked);
	};

	render() {
		const { authcode, saveAuth } = this.props;

		return (
			<div>
				<div className="login-fields-field">
					<span className="login-fields-field-label">
						<Str>Auth code</Str>
					</span>

					<OkInput
						className="login-fields-field-input"
						name="totp_code"
						value={authcode}
						placeholder="Authentication code"
						onChange={this._onChangeAuthcode}
					/>
				</div>

				<div className="login-fields-field">
					<OkCheckbox
						className="login-fields-field-checkbox"
						name="totp_save_device"
						label="Remember this device"
						value={saveAuth}
						onChange={this._onChangeSaveAuth}
						checked={saveAuth}
					/>
				</div>
			</div>
		);
	}
}

export default TwoFactor;



// WEBPACK FOOTER //
// ./src/apps/login/components/screens/TwoFactor.jsx